import { useBreadcrumb } from "@/components/breadcrumbs";
import { DiscoverContentV2 } from "./v2";

export const ExplorerContent = () => {
  useBreadcrumb("Discover");
  return <DiscoverContentV2 />;
};
